import React from "react";
export const events = [
  {
    date: "May 2017 - Jul 2018",
    title: "Full stack developer at a software company.",
    text: (
      <div>
        <div>Creating web applications with Angularjs and Angular 4.</div>
        <div>Deploying applications using VM, GCP, AWS.</div>
        <div>Working with databases like mongo and postgress.</div>
        <div>Using multiple frameworks in back-end like Express, Django, Ruby on rails,</div>
      </div>
    ),
  },
  {
    date: "Jul 2018 - Feb 2019",
    title: "Full stack developer at a financial findustry company",
    text: (
      <div>
        <div>Creating Web applications using React js with redux.</div>
        <div>Creating web API's in multiple frameworks like Nest JS, Expres JS and Srping.</div>
        <div>Deploying applications using VM, Docker and docker Compose.</div>
        <div>Working with databases like mongo and Mysql.</div>
      </div>
    ),
  },
  {
    date: "Dec 2018 - Sep 2019",
    title: "Full stack developer at the government innovation department",
    text: (
      <div>
        <div>Creating Web applications using React js with redux and mobx</div>
        <div>Deploying react components with Bit.dev</div>
        <div>Creating Web Api's using Graphql and microservices patterns</div>
        <div>Taking part in architecture decisions in frontend and backend Working with mongod</div>
      </div>
    ),
  },
  {
    date: "March 2020 - Sep 2020",
    title: "Full stack developer at Alio IT solutions",
    text: (
      <div>
        <div>Participating in an streaming web application development</div>
        <div>Creating Backend services using Domain Driven Design</div>
        <div>Contributing to a large React application</div>
      </div>
    ),
  },
  {
    date: "Sep 2020 - Jan 2022",
    title: "Software engineer and Solutions architect at the fitech Albo",
    text: (
      <div>
        <div>Adding new features to current frontend projects</div>
        <div>Collaborate cross-functionally to design and implement a tool to improve microservices event driven architecture</div>
        <div>Designed architecture, create infrastructure, code and lead an onboarding project for the company.</div>
      </div>
    ),
  },
  {
    date: "Jan 2022 - Oct 2022",
    title: "Software engineer at GBM",
    text: (
      <div>
        <div>Designed and created new features in the company by using AWS infrastructure.</div>
        <div>Programming and adding unit tests with C# and Nodejs.</div>
        <div>Working with databases like SQL Server and PostgreSQL and implementing event-driven solutions with SQS and SNS services.</div>
      </div>
    ),
  },
  {
    date: "Oct 2022 - Feb 2025",
    title: "Software engineer at Lyft",
    text: (
      <div>
        <div>Implemented new features in existing projects using Python and DynamoDB.</div>
        <div>Participating in projects that involved collaboration with other teams across the company.</div>
        <div>Took part of the oncall rotation, made incident reports and postmortems.</div>
        <div>Design solutions, create tech specs and make reviews to other ones.</div>
        <div>Conduct interviews to new candidates.</div>
      </div>
    ),
  }
].reverse();
